import { PiniaColada } from '@pinia/colada'
import messages from '@proj-airi/i18n/locales'
import { resolveSupportedLocale } from '@proj-airi/i18n'
import {
  browserAuthorizationHandler,
  registerAuthorizationHandler,
} from '@proj-airi/stage-ui/libs/auth'
import { setupSynced } from '@proj-airi/stage-ui/libs/pinia'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createI18n } from 'vue-i18n'

import App from './App.vue'
import AuthCallbackPage from './pages/AuthCallbackPage.vue'
import HomePage from './pages/HomePage.vue'

import './styles.css'

registerAuthorizationHandler(browserAuthorizationHandler)

const pinia = createPinia()
const synced = setupSynced()
pinia.use(synced.pinia)

const i18n = createI18n({
  legacy: false,
  locale: resolveSupportedLocale(localStorage.getItem('settings/language') || navigator.language || 'en', Object.keys(messages)),
  fallbackLocale: 'en',
  messages,
})

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: AuthCallbackPage,
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
})

createApp(App)
  .use(synced.vue)
  .use(router)
  .use(pinia)
  .use(PiniaColada)
  .use(i18n)
  .mount('#app')
